import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { AudioPlayer } from "./audio-player/audio-player.component";
import { CalendrierComponent } from "./calendrier/calendrier.component";
import { ClockComponent } from "./clock/clock.component";
import { ConversationUsersComponent } from "./conversation-users/conversation-users.component";
import { MapComponent } from "./map/map.component";
import { ParticulierFooterComponent } from "../pages/profiles/particulier/particulier-footer/particulier-footer.component";
import { InitialModalComponent } from "../pages/profiles/particulier/demande-service/services-around/initial-modal/initial-modal.component";
import { MapMarkerComponent } from "./map/map-marker.component";
import { MessagerierComponent } from "./messagerier/messagerier.component";
import { OnRoadModalComponent } from "./modals/on-road-modal/on-road-modal.component";
import { ProfileMenueComponent } from "./profile-menue/profile-menue.component";
import { SearchCountryComponent } from "./search-country/search-country.component";

import { HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FromNowPipe } from "../helpers/from-now.pipe";
import { ButtonComponent } from "./button/button.component";
import { ConfigurationProfilePage } from "./configuration-profile/configuration-profile.page";
import { ContactComponent } from "./contact/contact.component";
import { HeaderComponent } from "./header/header.component";
import { HeaderLocationButtonComponent } from "./header/header-location-button/header-location-button.component";
import { HeaderSearchButtonComponent } from "./header/header-search-button/header-search-button.component";
import { HomeCategoriesComponent } from "./home-categories/home-categories.component";
import { LiveProsBannerComponent } from "./live-pros-banner/live-pros-banner.component";
import { NearbyProsSectionComponent } from "./nearby-pros-section/nearby-pros-section.component";
import { HowItWorksSectionComponent } from "./how-it-works-section/how-it-works-section.component";
import { ActivityFeedSectionComponent } from "./activity-feed-section/activity-feed-section.component";
import { ReviewsSectionComponent } from "./reviews-section/reviews-section.component";
import { HomeCtaSectionComponent } from "./home-cta-section/home-cta-section.component";
import { DemandeServiceStepsComponent } from "./demande-service-steps/demande-service-steps.component";
import { DemandeServiceUploadCardComponent } from "./demande-service-upload-card/demande-service-upload-card.component";
import { DemandeServiceDescriptionCardComponent } from "./demande-service-description-card/demande-service-description-card.component";
import { DemandeServiceVoiceCardComponent } from "./demande-service-voice-card/demande-service-voice-card.component";
import { DemandeServiceSpecialityChipsComponent } from "./demande-service-speciality-chips/demande-service-speciality-chips.component";
import { DemandeServiceCtaComponent } from "./demande-service-cta/demande-service-cta.component";
import { DemandeServiceHeaderComponent } from "./demande-service-header/demande-service-header.component";
import { CustomRadioComponent } from "./custom-radio/custom-radio.component";
import { DayStartSwitcherComponent } from "./day-start-switcher/day-start-switcher.component";
import { GradiantButtonComponent } from "./gradiant-button/gradiant-button.component";
import { MediaReadersComponent } from "./media-readers/media-readers.component";
import { MessagerieTextInputComponent } from "./messagerie-text-input/messagerie-text-input.component";
import { BankLinkComponent } from "./modals/bank-link/bank-link.component";
import { BackgroundLocationAlwaysComponent } from "./modals/background-location-always/background-location-always.component";
import { LocationDisclosureComponent } from "./modals/location-disclosure/location-disclosure.component";
import { DiagnosticsConsentModalComponent } from "./modals/diagnostics-consent-modal/diagnostics-consent-modal.component";
import { CancelModalComponent } from "./modals/cancel-modal/cancel-modal.component";
import { CheckDevisPrixModalComponent } from "./modals/check-devis-prix-modal/check-devis-prix-modal.component";
import { DemandeSentComponent } from "./modals/demande-sent/demande-sent.component";
import { DevisSuccesModal } from "./modals/devis-succes-modal/devis-succes-modal.component";
import { FirstDemandComponent } from "./modals/first-demand/first-demand.component";
import { meetingConformationModalComponent } from "./modals/meeting-conformation-modal/meeting-conformation-modal.component";
import { MeetingDemandModalComponent } from "./modals/meeting-demand-modal/meeting-demand-modal.component";
import { WithdrawModalComponent } from "./modals/withdraw-modal/withdraw-modal.component";
import { WorkFinishedModalComponent } from "./modals/work-finished-modal/work-finished-modal.component";
import { OsmapComponent } from "./osmap/osmap.component";
import { MapkitComponent } from "./mapkit/mapkit.component";
import { SelectCardButtonComponent } from "./select-card-button/select-card-button.component";
import { SelectPaymentModalComponent } from "./select-payment-modal/select-payment-modal.component";
import { SignaturePadComponent } from "./signature-pad/signature-pad.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { VersionComponent } from "./version/version.component";
import { VoiceInputComponent } from "./voice-input/voice-input.component";
import { WornBlocComponent } from "./worn-bloc/worn-bloc.component";
import { PrestataireFooterComponent } from "./prestataire-footer/prestataire-footer.component";
import { DaySwitcherButtonsRoundComponent } from "./day-switcher-buttons-round/day-switcher-buttons-round.component";
import { SuccessModalComponent } from "./modals/success-modal/success-modal.component";
import { GoogleMapCustomIconComponent } from "./google-map-custom-icon/google-map-custom-icon.component";
import { FormComponentsModule } from "./form-components/form-components.module";
import { RoleCardComponent } from "./role-card/role-card.component";
import { RoleSelectorComponent } from "./register-components/role-selector/role-selector.component";
import { RegisterFooterComponent } from "./register-components/register-footer/register-footer.component";
import { RegisterHeaderComponent } from "./register-components/register-header/register-header.component";
import { CircularProgressComponent } from "./circular-progress/circular-progress.component";
import { AppLogoComponent } from "./app-logo/app-logo.component";
import { DefaultImageComponent } from "./default-image/default-image.component";
import { ScrollTrackerDirective } from "./directives/scroll-tracker.directive";
import { ProgressDonutComponent } from './progress-donut/progress-donut.component';
import { ReductionBadgeComponent } from './reduction-badge/reduction-badge.component';
import { BannerBadgeComponent } from './banner-badge/banner-badge.component';
import { LegalsModalComponent } from './modals/legals-modal/legals-modal.component';
import { ConfidentialModalComponent } from './modals/confidential-modal/confidential-modal.component';
import { CguClientModalComponent } from './modals/cgu-client-modal/cgu-client-modal.component';
import { LogViewerModalComponent } from './modals/log-viewer-modal/log-viewer-modal.component';
import { MaxNumberPipe } from "../helpers/pipe/max-number.pipe";
import { DistanceTrajetPipe } from "../helpers/pipe/distance-trajet.pipe";
import { DurationTrajetPipe } from "../helpers/pipe/duration-trajet.pipe";
import { ProviderStatsCardsComponent } from "./provider-stats-cards/provider-stats-cards.component";
import { ProviderEarningsCardComponent } from "./provider-earnings-card/provider-earnings-card.component";
import { ForcedPhoneCompletionModalComponent } from "./modals/forced-phone-completion-modal/forced-phone-completion-modal.component";
import { ForcedProfileCompletionModalComponent } from "./modals/forced-profile-completion-modal/forced-profile-completion-modal.component";
import { PermissionStepperComponent } from "./permissions/permission-stepper.component";
import { PermissionModalComponent } from "./permissions/permission-modal.component";
import { PermissionDetailComponent } from "./permissions/permission-detail.component";
import { LocationPermissionAlertComponent } from "./location-permission-alert/location-permission-alert.component";
import { DemandWaitOverlayComponent } from "./demand-wait-overlay/demand-wait-overlay.component";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    MapComponent,
    MapMarkerComponent,
    SearchCountryComponent,
    MessagerierComponent,
    ConversationUsersComponent,
    ClockComponent,
    CalendrierComponent,
    ProfileMenueComponent,
    AudioPlayer,
    FromNowPipe,
    DevisSuccesModal,
    MeetingDemandModalComponent,
    meetingConformationModalComponent,
    ContactComponent,
    HeaderComponent,
    HeaderLocationButtonComponent,
    HeaderSearchButtonComponent,
    HomeCategoriesComponent,
    LiveProsBannerComponent,
    NearbyProsSectionComponent,
    HowItWorksSectionComponent,
    ActivityFeedSectionComponent,
    ReviewsSectionComponent,
    HomeCtaSectionComponent,
    DemandeServiceStepsComponent,
    DemandeServiceUploadCardComponent,
    DemandeServiceDescriptionCardComponent,
    DemandeServiceVoiceCardComponent,
    DemandeServiceSpecialityChipsComponent,
    DemandeServiceCtaComponent,
    DemandeServiceHeaderComponent,
    MediaReadersComponent,
    OnRoadModalComponent,
    VersionComponent,
    SignaturePadComponent,
    CancelModalComponent,
    SpinnerComponent,
    ButtonComponent,
    SelectPaymentModalComponent,
    WithdrawModalComponent,
    SelectCardButtonComponent,
    FirstDemandComponent,
    DemandeSentComponent,
    BankLinkComponent,
    BackgroundLocationAlwaysComponent,
    LocationDisclosureComponent,
    DiagnosticsConsentModalComponent,
    OsmapComponent,
    MapkitComponent,
    CheckDevisPrixModalComponent,
    MessagerieTextInputComponent,
    VoiceInputComponent,
    WorkFinishedModalComponent,
    DayStartSwitcherComponent,
    ConfigurationProfilePage,
    WornBlocComponent,
    GradiantButtonComponent,
    CustomRadioComponent,
    SuccessModalComponent,
    GoogleMapCustomIconComponent,
    RoleCardComponent,
    RoleSelectorComponent,
    RegisterFooterComponent,
    RegisterHeaderComponent,
    CircularProgressComponent,
    AppLogoComponent,
    DefaultImageComponent,
    ScrollTrackerDirective,
    ProgressDonutComponent,
    ReductionBadgeComponent,
    BannerBadgeComponent,
    PrestataireFooterComponent,
    DaySwitcherButtonsRoundComponent,
    ParticulierFooterComponent,
    InitialModalComponent,
    LegalsModalComponent,
    ConfidentialModalComponent,
    CguClientModalComponent,
    LogViewerModalComponent,
    MaxNumberPipe,
    DistanceTrajetPipe,
    DurationTrajetPipe,
    ProviderStatsCardsComponent,
    ProviderEarningsCardComponent,
    ForcedPhoneCompletionModalComponent,
    ForcedProfileCompletionModalComponent,
    PermissionStepperComponent,
    PermissionModalComponent,
    PermissionDetailComponent,
    LocationPermissionAlertComponent,
    DemandWaitOverlayComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FormComponentsModule,
  ],

  exports: [
    MapMarkerComponent,
    RegisterFooterComponent,
    FormComponentsModule,
    CustomRadioComponent,
    MapComponent,
    ConfigurationProfilePage,
    ConversationUsersComponent,
    ClockComponent,
    CalendrierComponent,
    AudioPlayer,
    FromNowPipe,
    DevisSuccesModal,
    MeetingDemandModalComponent,
    meetingConformationModalComponent,
    ContactComponent,
    HeaderComponent,
    HeaderLocationButtonComponent,
    HeaderSearchButtonComponent,
    HomeCategoriesComponent,
    LiveProsBannerComponent,
    NearbyProsSectionComponent,
    HowItWorksSectionComponent,
    ActivityFeedSectionComponent,
    ReviewsSectionComponent,
    HomeCtaSectionComponent,
    DemandeServiceStepsComponent,
    DemandeServiceUploadCardComponent,
    DemandeServiceDescriptionCardComponent,
    DemandeServiceVoiceCardComponent,
    DemandeServiceSpecialityChipsComponent,
    DemandeServiceCtaComponent,
    DemandeServiceHeaderComponent,
    MediaReadersComponent,
    OnRoadModalComponent,
    VersionComponent,
    SignaturePadComponent,
    SpinnerComponent,
    CancelModalComponent,
    CancelModalComponent,
    ButtonComponent,
    SelectPaymentModalComponent,
    WithdrawModalComponent,
    SelectCardButtonComponent,
    FirstDemandComponent,
    DemandeSentComponent,
    BankLinkComponent,
    OsmapComponent,
    MapkitComponent,
    CheckDevisPrixModalComponent,
    WorkFinishedModalComponent,
    DayStartSwitcherComponent,
    WornBlocComponent,
    SuccessModalComponent,
    GoogleMapCustomIconComponent,
    RoleCardComponent,
    RoleSelectorComponent,
    RegisterHeaderComponent,
    CircularProgressComponent,
    AppLogoComponent,
    DefaultImageComponent,
    ScrollTrackerDirective,
    ProgressDonutComponent,
    ReductionBadgeComponent,
    BannerBadgeComponent,
    PrestataireFooterComponent,
    DaySwitcherButtonsRoundComponent,
    ParticulierFooterComponent,
    InitialModalComponent,
    MaxNumberPipe,
    DistanceTrajetPipe,
    DurationTrajetPipe,
    ProviderStatsCardsComponent,
    ProviderEarningsCardComponent,
    DemandWaitOverlayComponent,
  ], // Export the component
})
export class SharedModule {
  constructor() {
    // Add Font Awesome icons to the library
  }
}

